export default __webpack_public_path__ + "static/media/pro-sport-front.a99a2156.png";